<template>
  <div
    class="slideInOverlay"
    :class="{ 'is-open': isOpen, 'has-footer': hasFooter }"
  >
    <transition name="fade">
      <div
        class="slideInOverlay__background"
        v-if="isOpen"
        @click="close"
      ></div>
    </transition>

    <transition name="fade">
      <div class="slideInOverlay__close" v-if="isOpen" @click="close">
        <close-icon />
      </div>
    </transition>

    <div class="slideInOverlay__inner" :style="{ maxWidth: maxWidth }">
      <div class="slideInOverlay__body customscroll">
        <slot name="body"></slot>
      </div>
      <div class="slideInOverlay__footer" v-if="hasFooter">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "-!vue-svg-loader!../../images/close.svg";
export default {
  name: "SlideInOverlay",
  components: {
    CloseIcon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    maxWidth: {
      type: String,
      default: "768px",
    },
  },
  computed: {
    hasFooter() {
      return !!this.$slots.footer;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.slideInOverlay {
  &__background {
    background-color: rgba(0, 0, 0, 0.8);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 15;
  }

  &__close {
    position: fixed;
    top: 28px;
    right: 28px;
    z-index: 200;
    path {
      fill: #c6c6c6;
      transition: all 0.3s $t-nice;
    }

    &:hover {
      cursor: pointer;
      path {
        fill: $brand-orange;
      }
    }
  }

  &__inner {
    border-left: 4px solid $brand-orange;
    background-color: #fff;
    bottom: 0;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.5);
    opacity: 0;
    position: fixed;
    right: 0;
    top: 0;
    transform: translate(100%, 0);
    transition: transform 500ms $t-nice, opacity 300ms $t-nice;
    width: 100%;
    z-index: 20;

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &__body {
    bottom: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    right: 0;
    top: 0;
    padding: 85px 110px 70px;
  }

  &__footer {
    bottom: 0;
    height: 70px;
    left: 0;
    position: absolute;
    right: 0;
  }

  &.is-open {
    .slideInOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &.has-footer {
    .slideInOverlay__body {
      bottom: 70px;
    }
  }
}

@media all and (max-width: 669px) {
  .slideInOverlay {
    &__body {
      padding: 75px 85px 60px;
    }
  }
}

@media all and (max-width: 549px) {
  .slideInOverlay {
    &__body {
      padding: 50px 45px 40px;
    }
  }

  .o-fieldsgrid {
    &__field {
      width: 100%;
    }
  }
}
</style>
